import PeopleListPage from "@/pages/PeopleListPage";
export default function DirectorsPage() {
  return <PeopleListPage endpoint="medical_directors" title="Medical Directors" subtitle="MDs who approve NP coverage at each facility." kindLabel="director" />;
}
